import React
// , { useState }
from "react";
import "./Landing.css";
import logo from "../../assets/logo.png";
import Login from "../Login/Login";
import { 
	useNavigate,
	// Link 
} from "react-router-dom";

function Landing() {
	// const [signIn, setSignIn] = useState(false);
	const history = useNavigate();

	return (
		<div className="login">
			<div className="login_content">
				<img className="login_logo" src={logo} alt="Rokflix Logo" onClick={() => history("/")} />
				{/* <button
					className="login_button"
					onClick={() => setSignIn(true)}
				>
					Sign in
				</button> */}
				<div className="login_gradient"></div>
			</div>
			<div className="login_body">
				{/* {signIn ? ( */}
				<Login />
				{/* ) : (
					<>
						<h1>Unlimited movies, TV shows, and more.</h1>
						<h2>Watch anywhere. Cancel anytime.</h2>
						<h3>
							Ready to watch? Enter your email to create or
							restart your membership.
						</h3>
						<div className="login_input">
							<form>
								<input
									type="email"
									placeholder="Email address"
								/>
								<button
									className="btn_getStarted"
									onClick={() => setSignIn(true)}
								>
									Get started
								</button>
							</form>
						</div>
					</>
				)} */}
			</div>
		</div>
	);
}

export default Landing;
